export const SELECTED_CLIENT_STORAGE_KEY = 'sabar:selectedClientId'
